import { Header } from "components/Header/Header";
import "./styles/App.scss"
import { RouteProvider } from "./RouteProvider/RouteProvider";

function App() {
    return (
        <div className="App">
            <Header />
            <RouteProvider />
            <div className="glass"></div>
            <div className="background"></div>
        </div>
    );
}

export default App;
